export enum CRMTableFieldsLoadingActionTypes {
  SET_TABLE_FIELDS_LOADING = 'SET_TABLE_FIELDS_LOADING',
}

export const setTableFieldsLoading = (table: string) => ({
  type: CRMTableFieldsLoadingActionTypes.SET_TABLE_FIELDS_LOADING,
  payload: table,
})
